export const NAV_LINKS = {
  MARKETPLACE: '/marketplace',
  REQUESTS: '/my-requests',
  ASSIGNMENTS: '/my-assignments',
  TRANSPORTS: '/my-transports',
  TRANSPORT_REGISTRATION: '/transport-registration'
}

export const SCONTO = 3
export const PROPOSED_PAYMENT_PERIOD = 3
export const PAYMENT_PERIOD_TO_SHOW_POPUP = 30
export const DAYS_BETWEEN_SHOWING_PAYMENT_POPUP = 30
